/* eslint-disable react/jsx-key */
import React, { useState, useMemo } from 'react'
import { unitIdHeader, utilityHeader } from 'core/HeaderColTypeProps'
import {
  UtilityUnitSelection,
  getApiTargetInfo,
  getUnitNameMap,
  getUtilityNameMap,
} from 'core'
import { connect } from 'react-redux'
import {
  getBfNyIsoDerateGroup,
  deleteBfNyIsoDerateGroup,
  insertBfNyIsoDerateGroup,
} from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { Button } from 'antd'
import { Label } from 'core/screen-util'

const headers = [utilityHeader, unitIdHeader]

const retrieveTask = apiTargetInfo => getBfNyIsoDerateGroup(apiTargetInfo)

// const modifyTask = apiTargetInfo => data => postCompanyInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteBfNyIsoDerateGroup(apiTargetInfo)(data)

const title = 'NYISO Derates Group'

const NyIsoDerateGroup = ({ utilityNameMap, unitNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '150px 500px 100px 150px 100px',
      }}
    >
      <Label>Select Utility/Unit : </Label>
      <UtilityUnitSelection
        utility={insertData.utility}
        unit={insertData.unitId}
        onUnitChange={value => {
          // setUtilityUnit(value)
          setInsertData({
            ...insertData,
            utility: value[0],
            unit: value[1].substr(3),
            unitId: value[1],
          })
        }}
        casStyle={{ marginLeft: '5px' }}
      />
      <Button type="primary" onClick={() => onAdd(true)}>
        Add
      </Button>
      <Button
        style={{ marginLeft: '20px' }}
        type="primary"
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button style={{ marginLeft: '20px' }} type="danger" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [unitNameMap, utilityNameMap]
  )

  return (
    <CommonScreen
      title={title}
      header={headerWithFormatter}
      saveTask={insertBfNyIsoDerateGroup}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.utility}
      autoRetrieve
      // sortOptions={[{ ident: 'companyName', display: 'Company Name', sortOrder: 'asc' }]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={100}
      onInsertEvent={b => setInsertEvent(b)}
      //   withoutModify
      totalWidth={800}
      withDelete
      sortOptions={headers}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(NyIsoDerateGroup)
